module.exports = __webpack_public_path__ + "static/media/9.3a7dd6bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/9.png
// module id = 1437
// module chunks = 0